/**
 * Origen del candidato (RH-06).
 *
 * Ojo con los dos conceptos que suenan igual y no lo son:
 *
 * - `captureMethod` lo pone el backend segun por cual puerta entro el
 *   registro (formulario publico o alta manual). No se captura.
 * - `source` es lo que el candidato declara: de donde se entero de la vacante.
 *   Sale de un catalogo que se administra en Configuracion.
 *
 * Este archivo es del segundo.
 */

export type VisibilidadDeOrigen = 'public' | 'internal'

export interface OrigenDeCandidato {
  id: number
  name: string
  visibility: VisibilidadDeOrigen
  /** Si al elegirlo hay que pedir a quien recomendo al candidato. */
  isReferral: boolean
  isActive: boolean
  sortOrder: number
}

/**
 * El nombre de quien recomendo solo aplica a los origenes marcados como
 * recomendacion. Se centraliza aqui porque lo consultan el formulario publico,
 * el alta manual y la ficha, y las tres tienen que coincidir: si una pide el
 * campo y otra no, el backend rechaza lo que la primera deja pasar.
 */
export const pideQuienRecomendo = (
  origenes: OrigenDeCandidato[],
  sourceId: number | null | undefined,
): boolean =>
  Boolean(sourceId) &&
  origenes.some((o) => o.id === sourceId && o.isReferral)

/**
 * Una recomendacion esta pendiente de vincular cuando se sabe quien la hizo
 * pero todavia no se dijo a quien del directorio corresponde.
 *
 * Es el filtro del tablero. Se deja de pendiente en cuanto hay vinculacion, no
 * en cuanto hay texto: el texto llega desde el primer dia y lo que falta es la
 * decision de RH.
 */
export const esRecomendacionPendiente = (candidato: {
  source?: { isReferral?: boolean } | null
  referredByEmployeeId?: number | null
}): boolean =>
  Boolean(candidato.source?.isReferral) && !candidato.referredByEmployeeId

/** Lo que se muestra cuando el candidato no declaro origen. */
export const SIN_ORIGEN = 'No especificado'
